export default __webpack_public_path__ + "ff7a98318a84c700e81ec6578aef45bc.jpg";